import React, { useState, useContext } from 'react';
import { connect } from 'react-redux';
import { KFLInput } from '@kamstrup/kamstrup-frontend-library';
import { ReduxState } from '../../interfaces';
import { useLifecycle } from '../../hooks/useLifecycle';
import * as DTypes from '../../modules/devicetypes';
import SidebarForm from './sidebarForm';
import { Groups } from '../../models';
import { resetScroll } from '../../modules/datatable';
import { LocaleCtx } from '../../contexts/locale.context';

interface StateProps {
  filterCriteria: DTypes.FilterCriteria;
  isLoading: boolean;
}

type IProps = StateProps & { id: string };

const DTypesSidebar: React.FC<IProps> = (props) => {
  useLifecycle('DTypeSidebar');
  const [deviceName, setDeviceName] = useState(props.filterCriteria.deviceName);

  const handleSearch = () => {
    const criteria = { ...props.filterCriteria, deviceName };
    DTypes.updateFilterCriteria(criteria, props.isLoading);
    resetScroll();
  };

  const handleClear = () => setDeviceName('');

  const { translate } = useContext(LocaleCtx);
  const deviceNameTranslated = translate(DTypes.msgDeviceName);
  return (
    <SidebarForm
      group={Groups.DEVICETYPES}
      fnSearch={handleSearch}
      fnClear={handleClear}
      isLoading={props.isLoading}
    >
      <KFLInput
        id="sb_dtypes_filter_id"
        label={deviceNameTranslated}
        placeholder={deviceNameTranslated}
        value={String(deviceName)}
        onChange={setDeviceName}
      />
    </SidebarForm>
  );
};

const mapStateToProps = (state: ReduxState) => ({
  isLoading: state.deviceTypesState.table.isLoading,
  filterCriteria: state.deviceTypesState.filters,
});

export default connect(mapStateToProps)(DTypesSidebar);
